import { render, staticRenderFns } from "./table-filter.vue?vue&type=template&id=5a4a0f66&scoped=true&"
import script from "./table-filter.vue?vue&type=script&lang=js&"
export * from "./table-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a0f66",
  null
  
)

export default component.exports